import { queryIntakeForms } from '@wix/ambassador-intake-forms-v1-intake-form/http';
import {
  IntakeForm,
  QueryIntakeFormsResponse,
} from '@wix/ambassador-intake-forms-v1-intake-form/types';
import { FormApiContext, withErrorBoundary } from '../utils';
import { ServerErrorType } from '../../../types/errors';
import { QueryIntakeFormArgs } from './index';

export const queryIntakeForm = async ({
  formId,
  httpClient,
  reportError,
  onError,
}: QueryIntakeFormArgs & FormApiContext): Promise<IntakeForm | undefined> => {
  const { data, error } = await withErrorBoundary(
    {
      fn: async () => {
        const response = await httpClient.request<QueryIntakeFormsResponse>(
          queryIntakeForms({
            query: {
              filter: {
                id: formId,
              },
            },
          }),
        );

        return response.data?.intakeForms?.[0];
      },
      mapError: (e) => ({
        error: ServerErrorType.FAILED_TO_QUERY_INTAKE_FORM,
        shouldReport: true,
      }),
      fallback: undefined,
    },
    reportError,
  );

  if (error) {
    onError?.(error);
  }

  return data;
};
